import type { CatalogOption } from '@core/utils/catalog-option.util';

// Tipos de documento de identidad (sin menor sin documento, ya que es para empleados)
export const EMPLOYEE_DOCUMENT_TYPE_OPTIONS = [
  { value: 'CEDULA', label: 'Cédula' },
  { value: 'PASAPORTE', label: 'Pasaporte' },
  { value: 'DOCUMENTO_EXTRANJERO', label: 'Documento Extranjero' },
];

export const BLOOD_TYPE_OPTIONS = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' },
];

/*
 * Sexo, estado civil y escolaridad: el catálogo común de `@core` (los mismos
 * códigos que guarda el módulo de pacientes en las mismas columnas de
 * `partners`). El expediente laboral sólo ofrece M/F: ver
 * `EMPLOYEE_GENDER_OPTIONS`.
 */
export {
  EMPLOYEE_GENDER_OPTIONS as GENDER_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  EDUCATION_LEVEL_OPTIONS,
} from '@core/constants/person-demographics.constant';

/*
 * Tipo y método de pago del salario. Son exactamente los que acepta el API
 * (`employee-salary.entity.ts`): la vigencia salarial y el expediente leen de
 * aquí para no ofrecer valores que el servidor rechaza.
 */
export type SalaryPaymentType = 'fixed' | 'hourly' | 'variable';
export type SalaryPaymentMethod = 'bank_transfer' | 'check' | 'cash';

export const SALARY_PAYMENT_TYPE_OPTIONS: CatalogOption<SalaryPaymentType>[] = [
  { value: 'fixed', label: 'Fijo' },
  { value: 'hourly', label: 'Por hora' },
  { value: 'variable', label: 'Variable' },
];

export const SALARY_PAYMENT_METHOD_OPTIONS: CatalogOption<SalaryPaymentMethod>[] = [
  { value: 'bank_transfer', label: 'Transferencia bancaria' },
  { value: 'check', label: 'Cheque' },
  { value: 'cash', label: 'Efectivo' },
];
